import type { AgentV2ChatResponse } from "@/agent/types";

/** A final answer is a turn-scoped commit, never a global display string. */
export interface TurnFinalAnswer {
  turnId: string;
  answer: string;
  planStatus: string;
}

export function createTurnFinalAnswer(
  activeTurnId: string,
  turnId: string,
  answer?: string,
  planStatus = "completed"
): TurnFinalAnswer | null {
  const text = answer?.trim() || "";
  if (!text || !turnId || activeTurnId !== turnId) return null;
  return { turnId, answer: text, planStatus };
}

/**
 * Keep the response object and the dedicated final-answer channel consistent.
 * Replacing the response object also wakes the chat widget if a prop watcher
 * missed an earlier scalar assignment during a page transition.
 */
export function mergeTurnFinalAnswer(
  response: AgentV2ChatResponse | null,
  committed: TurnFinalAnswer
): AgentV2ChatResponse | null {
  if (!response || response.turnId !== committed.turnId) return response;
  return {
    ...response,
    answer: committed.answer,
    status: committed.planStatus || "completed"
  };
}
